import { LaunchButton } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { dataLockerLandingPageSelectedTabAtom } from '@/atoms/dataLocker/landingPage';

export const ExploreLaunchButton = () => {
  const { t } = useTranslation('dataLocker');
  const selectedTab = useAtomValue(dataLockerLandingPageSelectedTabAtom);

  return (
    <LaunchButton iconPosition="top" icon="IqScout" as={Link} to={selectedTab}>
      {t(`landingPage.${selectedTab}.launchButton`)}
    </LaunchButton>
  );
};
